import { store } from './../index'
import { Navigate, Outlet, useSearchParams } from 'react-router-dom'

const PublicRoutes = () => {
  const auth = store.getState().loginReducer.token
  let [searchParams] = useSearchParams()

  const reDirect = searchParams.get('go')

  return auth ? <Navigate to={reDirect || '/'} /> : <Outlet />
}

export default PublicRoutes
